





















import { Vue, Component, Prop } from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import ReviewDependents from "@/employee/components/onboarding/ReviewDependents.vue";
import ReviewHealthPlan from "@/employee/components/onboarding/ReviewHealthPlan.vue";
import ReviewPersonalDetails from "@/employee/components/onboarding/ReviewPersonalDetails.vue";
import ReviewTerms from "@/employee/components/onboarding/ReviewTerms.vue";
import { useWizardStore } from "@/employee/store/wizard";
import { UserOnboardingSteps } from "@/shared/userOnboarding";

@Component({
  components: {
    Button,
    ReviewDependents,
    ReviewHealthPlan,
    ReviewPersonalDetails,
    ReviewTerms
  }
})
export default class Review extends Vue {
  wizardStore = useWizardStore();

  @Prop({ required: true })
  onBack: (hasUnsavedChanges: boolean) => void;

  get shouldShowDependents () {
    if (!this.wizardStore.onboardingWizard || !this.wizardStore.onboardingWizard.statuses) {
      return false;
    }

    return this.wizardStore.onboardingWizard.statuses.some(s => s.step === UserOnboardingSteps.YourFamily);
  }

  onSubmit () {
    this.$emit("complete");
  }

  goBack () {
    this.onBack(false);
  }
}
